export default "__VITE_ASSET__BfZl6Kay__"